module.exports = __webpack_public_path__ + "static/media/4 lion back black white.1280x1674.3b8f87b3.webp";